<template>

  <mainView></mainView>

</template>

<script>
// import HomeView from './components/Home.vue'
// import HomeView from './view/Home.vue'
import mainView from './Main.vue'
export default {
  name: 'App',
  components: {
    mainView
  }
}


</script>

<style>
#bee_nReward {
  background-color: transparent;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 12px;
  z-index: 2100;
  transition: transform 700ms;
  border: none;
  flex-direction: column;
  justify-content: center;
  display: flex;
  align-items: center;
}
</style>
